// extracted by mini-css-extract-plugin
module.exports = {"section":"v_l","partners":"v_bq","partner":"v_br","partnerImage":"v_bs"};